import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import GalleriaCard from "./GalleriaCard";

function Galleria() {
  return (
    <section>
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center"}}>
            <Col
              md={12} // 12 (full width) per dare spazio alle foto
              style={{
                justifyContent: "center",
                paddingTop: "10px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                <strong className="purple">Galleria</strong>
              </h1>
              <h4>Qui troverai i miei ricordi legati a <span className="purple">Tecno/Zero</span> ed <span className="purple">Atlantis</span> nel corso degli anni. <br />Se sei da telefono, ruota lo schermo in orizzontale per un'esperienza migliore.</h4>
              <GalleriaCard />
              
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Galleria;